export const TRIBUTE_VIDEO_LIMIT_EXCEEDED_ERROR_CODE = 'TributeVideoLimitExceeded';
export const STORAGE_LIMIT_EXCEEDED_ERROR_CODE = 'StorageLimitExceeded';
export const CEREMONIES_LIMIT_EXCEEDED_ERROR_CODE = 'CeremoniesLimitExceeded';
export const TIME_LIMIT_EXCEEDED_ERROR_CODE = 'TimeLimitExceeded';
